export default "__VITE_ASSET__BUjz0dt$__"